import {combineReducers} from "redux";
import OrganizationInformationReducers from "../../organization-information/store/organization-information-reducers";
import {OrganizationUsersReducers} from "../../organization-users/store/organization-users-reducers";

export const OrganizationStoreReducers = combineReducers({
    users: OrganizationUsersReducers,
    information: OrganizationInformationReducers,
});

